import { aboutValues } from "@/mocks/comicData";

const testimonials = [
  {
    name: "林同学",
    role: "在校大学生 · 二次元爱好者",
    text: "以前总在一个平台找不到全，来回切换很烦。现在照着榜单一次找齐了主力平台，追更再也没断过。",
  },
  {
    name: "阿澈",
    role: "国漫读者",
    text: "攻略写得很实在，试读那几步帮了大忙，终于找到画风和更新都合拍的平台了。",
  },
  {
    name: "小鹿",
    role: "韩漫爱好者",
    text: "分类专区很清晰，条漫体验那篇文章特别实用，护眼模式的小技巧每天都用得上。",
  },
];

export default function About() {
  return (
    <section id="about" className="section-x py-14 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.3fr_1fr]">
        <div>
          <p className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
            <span className="h-2 w-2 rounded-full bg-primary-500"></span>
            关于我们
          </p>
          <h2 className="mt-2 font-heading text-3xl text-foreground-900 md:text-4xl">帮每一位读者找对看漫画的地方</h2>
          <p className="mt-4 leading-relaxed text-foreground-600">
            漫阅指南是一支专注漫画阅读体验的内容团队。我们长期体验并跟踪主流漫画平台，围绕正版内容、高清画质、更新速度与使用体验，为大家提供客观、可落地的平台推荐与追更攻略。
          </p>
          <p className="mt-3 leading-relaxed text-foreground-600">
            我们坚持只推荐拥有正式授权的规范平台，倡导理性、长久、可持续的追更方式，让好故事与好创作者都能被看见。
          </p>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {aboutValues.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200/70 bg-background-100/60 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 text-lg font-semibold text-foreground-900">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-lg border border-background-200/70 bg-background-50 p-5">
              <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
              <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                  <i className="ri-user-3-line"></i>
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{t.name}</span>
                  <span className="block text-xs text-foreground-500">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}